export default "__VITE_ASSET__D$71auPr__"